import React from 'react';
import { useApp } from '@/context/AppContext';
import { Wifi, WifiOff, RefreshCw } from 'lucide-react';

export const SyncPill = () => {
  const { syncStatus, pendingCount } = useApp();
  const map = {
    synced: { cls: 'bg-emerald-50 text-emerald-800 ring-1 ring-emerald-200', label: 'Synced', icon: <Wifi className="h-3 w-3" /> },
    syncing: { cls: 'bg-amber-50 text-amber-800 ring-1 ring-amber-200', label: pendingCount > 0 ? `Syncing ${pendingCount}` : 'Syncing', icon: <RefreshCw className="h-3 w-3 animate-spin" /> },
    offline: { cls: 'bg-rose-50 text-rose-800 ring-1 ring-rose-200', label: 'Offline', icon: <WifiOff className="h-3 w-3" /> },
  };
  const s = map[syncStatus];
  return (
    <span data-testid="sync-status-pill"
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ${s.cls}`}>
      {s.icon}{s.label}
    </span>
  );
};
